if (!customElements.get('splide-carousel')) {
  customElements.define(
    'splide-carousel',
    class SplideCarousel extends HTMLElement {
      constructor() {
        super()
        this.carousel = null
        this.nextArrows = null
        this.prevArrows = null
        this.splideIndicators = null
        this.splideRangeSlider = null
        this.splideId = this.getAttribute('data-splide-id')
        this.config = JSON.parse(this.getAttribute('data-splide'))
        if (this.splideId) this.mountCarousel()
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (document.querySelector(`[data-block-id="${e.detail.blockId}"][data-splide-id="${this.splideId}"]`)) {
              this.carousel.go(parseInt(e.target.dataset.slideIndex))
              this.carousel.Components.Autoplay.pause()
            }
          })
          document.addEventListener('shopify:section:deselect', (e) => {
            if (document.querySelector('[data-section-id="' + e.detail.sectionId + '"]')) {
              if (this.config.autoplay != undefined) {
                this.carousel.go(0)
                this.carousel.Components.Autoplay.play()
              }
            }
          })
          document.addEventListener('shopify:section:load', (e) => {
            const { sectionId } = e.detail
            const hasElement = e.target.id.indexOf(sectionId) != -1
            // reload product recommendations after switching settings
            if (hasElement) {
              this.carousel.destroy()
              this.mountCarousel()
            }
          })
        }
      }
      mountCarousel() {
        this.carousel = new Splide(this)

        
        this.carousel.mount()
        
        let isQuickViewSplide = this.getAttribute('data-quick-view-splide')

        isQuickViewSplide != null ? document.addEventListener('variant:changed', this.updateVariantImage.bind(this)) : null

        this.nextArrows = document.querySelectorAll(`[data-splide-next][data-splide-id="${this.splideId}"]`)
        this.prevArrows = document.querySelectorAll(`[data-splide-prev][data-splide-id="${this.splideId}"]`)
        this.splideIndicators = document.querySelectorAll(`[data-splide-indicator][data-splide-id="${this.splideId}"]`)
        this.splideRangeSlider = document.querySelector(`[data-splide-range-slider][data-id="${this.splideId}"]`)

        this.nextArrows != null && this.prevArrows != null ? this.bindArrowActions() : null
        this.splideIndicators != null ? this.bindIndicators() : null
        this.splideRangeSlider != null ? this.bindScrollPosition() : null

        this.carousel.on('moved', this.carouselMoved.bind(this))
      }

      updateVariantImage(e){
        let position = e.detail.variant.featured_media.position

        let slideInPosition = this.querySelector(`.splide__slide[data-position="${position}"]`);
        let slideIndex = null

        slideInPosition ? slideIndex = slideInPosition.getAttribute('data-slide-index') : null
        
        if(slideIndex){
          slideIndex = parseInt(slideIndex);
          this.carousel.go(slideIndex);
        }
      }
      carouselMoved(e) {
        // add gradient 'fades' to the beginning and end of track when moving
        if (this.carousel.root.dataset.splideFadeEdges) {
          const splideTrack = this.carousel.root.querySelector('.splide__track')
          if (!this.carousel.root.querySelector('.splide__slide:last-child').classList.contains('is-active')) {
            splideTrack.classList.add('fade-right')
          } else {
            splideTrack.classList.remove('fade-right')
          }
          if (!this.carousel.root.querySelector('.splide__slide:first-child').classList.contains('is-visible')) {
            splideTrack.classList.add('fade-left')
          } else {
            splideTrack.classList.remove('fade-left')
          }
        }
        if (this.splideIndicators != null) {
          this.splideIndicators.forEach((indicator) => {
            indicator.classList.contains('active') ? indicator.classList.remove('active') : null
            let indexClicked = parseInt(indicator.getAttribute('data-splide-index'))
            let currentIndex = this.carousel.Components.Controller.getIndex()
            if (indexClicked == currentIndex) {
              indicator.classList.add('active')
            }
          })
        }
        if(this.splideRangeSlider != null){
          let currentIndex = this.carousel.Components.Controller.getIndex()
          this.splideRangeSlider.value = currentIndex
        }
      }
      bindArrowActions() {
        this.nextArrows.forEach((nextArrow) => {
          nextArrow.addEventListener('click', this.moveCarousel.bind(this))
        })
        this.prevArrows.forEach((prevArrow) => {
          prevArrow.addEventListener('click', this.moveCarousel.bind(this))
        })
      }
      bindIndicators() {
        this.splideIndicators.forEach((indicator) => {
          indicator.addEventListener('click', this.navigateToIndex.bind(this))
        })
      }
      bindScrollPosition() {
        this.splideRangeSlider.addEventListener('input', this.updateScrollPosition.bind(this))
      }
      moveCarousel(e) {
        e.preventDefault()
        let next = e.currentTarget.dataset.splideNext === '' ? true : false
        if (next) {
          let slides = this.querySelectorAll('.splide__slide')
          let lastSlide = slides[slides.length - 1]
          if (this.config.type != undefined || this.config.rewind != undefined) {
            this.carousel.go('>')
          } else if (this.config.type == undefined && !lastSlide.classList.contains('is-visible')) {
            this.carousel.go('>')
          }
        } else {
          this.carousel.go('<')
        }
      }
      navigateToIndex(e) {
        e.preventDefault()
        this.splideIndicators.forEach((indicator) => {
          indicator.classList.remove('active')
        })
        let button = e.currentTarget
        button.classList.add('active')
        let splideIndex = parseInt(button.getAttribute('data-splide-index'))
        this.carousel.go(splideIndex)
      }
      updateScrollPosition(e) {
        let scrollValue = parseInt(e.target.value)
        this.carousel.go(scrollValue)
      }
    }
  )
}
